import { SelectionType } from './segments';
import { SessionConditionType } from '../audience/components/session-condition-group.model';

export const CATEGORIES_FOR_PEOPLE: CriteriaGroup[] = [
  {
    type: 'activity', // This is Activity in translation
    options: [
      {
        name: 'campaigns',
        icon: 'format_underlined',
        formFieldType: 'AutoCompleteField',
        pageVisibility: [SelectionType.Visits, SelectionType.People],
      },
      {
        name: 'notCampaigns',
        icon: 'format_underlined',
        formFieldType: 'AutoCompleteField',
        pageVisibility: [SelectionType.People],
      },
      {
        name: 'goals',
        icon: 'card_membership',
        formFieldType: 'AutoCompleteField',
        pageVisibility: [SelectionType.Visits, SelectionType.People],
      },
      {
        name: 'notGoals',
        icon: 'card_membership',
        formFieldType: 'AutoCompleteField',
        pageVisibility: [SelectionType.People],
      },
      {
        name: 'profilings',
        icon: 'collections_bookmark',
        formFieldType: 'AutoCompleteField',
        pageVisibility: [SelectionType.Visits, SelectionType.People],
      },
      {
        name: 'visitedPages',
        icon: 'library_books',
        formFieldType: 'AutoCompleteField',
        pageVisibility: [SelectionType.Visits, SelectionType.People],
      },
    ],
  },
  {
    type: 'widgets', // This is Campaign activity in translation
    options: [
      {
        name: 'widget-opens',
        icon: 'visibility',
        formFieldType: 'MultiDropdown',
        pageVisibility: [SelectionType.People],
      },
      {
        name: 'widget-conversions',
        icon: 'stars',
        formFieldType: 'MultiDropdown',
        pageVisibility: [SelectionType.People],
      },
      {
        name: 'widget-dissmissals',
        icon: 'disabled_by_default',
        formFieldType: 'MultiDropdown',
        pageVisibility: [SelectionType.People],
      },
      {
        name: 'widget-clickthroughs',
        icon: 'mouse',
        formFieldType: 'MultiDropdown',
        pageVisibility: [SelectionType.People],
      },
      {
        name: 'widget-survey-response',
        icon: 'mouse',
        formFieldType: 'MultiDropdown',
        pageVisibility: [SelectionType.People],
      },
      {
        name: 'nps-score',
        icon: 'looks_one',
        formFieldType: 'NumberField',
        pageVisibility: [SelectionType.People],
      },
      {
        name: 'csat-score',
        icon: 'mood',
        formFieldType: 'NumberField',
        pageVisibility: [SelectionType.People],
      },
      {
        name: 'widget-copy-coupon',
        svgIcon: 'tb:discount-code',
        formFieldType: 'MultiDropdown',
        pageVisibility: [SelectionType.People],
      },
    ],
  },
  {
    type: 'user', // This is Contact
    options: [
      {
        name: 'labels',
        icon: 'flag',
        formFieldType: 'MultiDropdown',
        pageVisibility: [SelectionType.Visits, SelectionType.People],
      },
      {
        name: 'totalVisitsPeople',
        icon: 'timeline',
        formFieldType: 'NumberField',
        pageVisibility: [SelectionType.People],
      },
      {
        name: 'consent',
        icon: 'playlist_add_check',
        formFieldType: 'MultiDropdown',
        pageVisibility: [SelectionType.People],
      },
    ],
  },
];

export const CATEGORIES_FOR_VISITS: CriteriaGroup[] = [
  {
    type: 'source',
    options: [
      {
        name: 'socialMedia',
        icon: 'group',
        formFieldType: 'none',
        requiresPopup: false,
        pageVisibility: [SelectionType.Visits],
      },
      {
        name: 'facebook',
        svgIcon: 'tb:facebook',
        formFieldType: 'none',
        requiresPopup: false,
        pageVisibility: [SelectionType.Visits],
      },
      {
        name: 'linkedIn',
        svgIcon: 'tb:linkedin',
        formFieldType: 'none',
        requiresPopup: false,
        pageVisibility: [SelectionType.Visits],
      },
      {
        name: 'campaigns',
        icon: 'format_underlined',
        formFieldType: 'AutoCompleteField',
        pageVisibility: [SelectionType.Visits, SelectionType.People],
      },
      {
        name: 'utmSource',
        icon: 'format_underlined',
        formFieldType: 'TextField',
        pageVisibility: [SelectionType.Visits],
      },
      {
        name: 'utmMedium',
        icon: 'format_underlined',
        formFieldType: 'TextField',
        pageVisibility: [SelectionType.Visits],
      },
      {
        name: 'referrerURL',
        icon: 'link',
        formFieldType: 'TextField',
        pageVisibility: [SelectionType.Visits],
      },
      {
        name: 'paidTraffic',
        icon: 'monetization_on',
        formFieldType: 'none',
        requiresPopup: false,
        pageVisibility: [SelectionType.Visits],
      },
      {
        name: 'emailCampaigns',
        icon: 'email',
        formFieldType: 'none',
        requiresPopup: false,
        pageVisibility: [SelectionType.Visits],
      },
    ],
  },
  {
    type: 'session',
    options: [
      {
        name: 'goals',
        icon: 'card_membership',
        formFieldType: 'AutoCompleteField',
        pageVisibility: [SelectionType.Visits, SelectionType.People],
      },
      {
        name: 'notGoals',
        icon: 'card_membership',
        formFieldType: 'AutoCompleteField',
        pageVisibility: [SelectionType.Visits],
      },
      {
        name: 'profilings',
        icon: 'collections_bookmark',
        formFieldType: 'AutoCompleteField',
        pageVisibility: [SelectionType.Visits, SelectionType.People],
      },
      {
        name: 'siteTime',
        icon: 'restore',
        formFieldType: 'NumberField',
        pageVisibility: [SelectionType.Visits],
      },
      {
        name: 'pageViews',
        icon: 'library_books',
        formFieldType: 'NumberField',
        pageVisibility: [SelectionType.Visits],
      },
      {
        name: 'country',
        icon: 'public',
        formFieldType: 'MultiDropdown',
        pageVisibility: [SelectionType.Visits],
      },
      {
        name: 'visitedPages',
        icon: 'library_books',
        formFieldType: 'AutoCompleteField',
        pageVisibility: [SelectionType.Visits, SelectionType.People],
      },
    ],
  },
  {
    type: 'widgets', // This is Campaign activity in translation
    options: [
      {
        name: 'widget-opens',
        icon: 'visibility',
        formFieldType: 'MultiDropdown',
        pageVisibility: [SelectionType.Visits],
      },
      {
        name: 'widget-conversions',
        icon: 'stars',
        formFieldType: 'MultiDropdown',
        pageVisibility: [SelectionType.Visits],
      },
      {
        name: 'widget-dissmissals',
        icon: 'disabled_by_default',
        formFieldType: 'MultiDropdown',
        pageVisibility: [SelectionType.Visits],
      },
      {
        name: 'widget-clickthroughs',
        icon: 'mouse',
        formFieldType: 'MultiDropdown',
        pageVisibility: [SelectionType.Visits],
      },
      {
        name: 'widget-survey-response',
        icon: 'stars',
        formFieldType: 'MultiDropdown',
        pageVisibility: [SelectionType.Visits],
      },
      {
        name: 'widget-copy-coupon',
        svgIcon: 'tb:discount-code',
        formFieldType: 'MultiDropdown',
        pageVisibility: [SelectionType.Visits],
      },
    ],
  },
  {
    type: 'user', // This is Contact
    options: [
      {
        name: 'labels',
        icon: 'flag',
        formFieldType: 'MultiDropdown',
        pageVisibility: [SelectionType.Visits, SelectionType.People],
      },
      {
        name: 'identified',
        icon: 'account_box',
        formFieldType: 'RadioButtonField',
        pageVisibility: [SelectionType.Visits],
      },
      {
        name: 'totalVisits',
        icon: 'timeline',
        formFieldType: 'NumberField',
        pageVisibility: [SelectionType.Visits],
      },
    ],
  },
];

export const CATEGORIES_FOR_AUDIENCE: CriteriaGroup[] = [
  {
    type: 'source',
    options: [
      {
        name: 'otherSocialMediaVisit',
        type: SessionConditionType.OtherSocialMediaVisit,
        icon: 'group',
        formFieldType: 'none',
        requiresPopup: false,
        pageVisibility: [SelectionType.Audience],
      },
      {
        name: 'facebookVisit',
        type: SessionConditionType.FacebookVisit,
        svgIcon: 'tb:facebook',
        formFieldType: 'none',
        requiresPopup: false,
        pageVisibility: [SelectionType.Audience],
      },
      {
        name: 'instagramVisit',
        type: SessionConditionType.InstagramVisit,
        svgIcon: 'tb:instagram',
        formFieldType: 'none',
        requiresPopup: false,
        pageVisibility: [SelectionType.Audience],
      },
      {
        name: 'utmCampaign',
        type: SessionConditionType.UTMCampaign,
        icon: 'format_underlined',
        formFieldType: 'AutoCompleteField',
        requiresPopup: true,
        pageVisibility: [SelectionType.Audience],
      },
      {
        name: 'utmSource',
        type: SessionConditionType.UTMSource,
        icon: 'format_underlined',
        formFieldType: 'TextField',
        requiresPopup: true,
        pageVisibility: [SelectionType.Audience],
      },
      {
        name: 'utmMedium',
        type: SessionConditionType.UTMMedium,
        icon: 'format_underlined',
        formFieldType: 'TextField',
        requiresPopup: true,
        pageVisibility: [SelectionType.Audience],
      },
      {
        name: 'marketingEmailVisit',
        type: SessionConditionType.MarketingEmailVisit,
        icon: 'email',
        formFieldType: 'none',
        requiresPopup: false,
        pageVisibility: [SelectionType.Audience],
      },
      {
        name: 'newVisitor',
        type: SessionConditionType.NewVisitor,
        icon: 'person',
        formFieldType: 'none',
        requiresPopup: false,
        pageVisibility: [SelectionType.Audience],
      },
      {
        name: 'returningVisitor',
        type: SessionConditionType.ReturningVisitor,
        icon: 'person',
        formFieldType: 'NumberField',
        requiresPopup: false,
        pageVisibility: [SelectionType.Audience],
      },
    ],
  },
  {
    type: 'browser',
    options: [
      {
        name: 'browserLanguage',
        type: SessionConditionType.BrowserLanguage,
        icon: 'translate',
        requiresPopup: true,
        formFieldType: 'MultiDropdown',
        pageVisibility: [SelectionType.Audience],
      },
      {
        name: 'query',
        type: SessionConditionType.Query,
        icon: 'http',
        formFieldType: 'none',
        requiresPopup: false,
        pageVisibility: [SelectionType.Audience],
      },
      {
        name: 'cookieExists',
        type: SessionConditionType.CookieExists,
        icon: 'code',
        formFieldType: 'TextField',
        requiresPopup: true,
        pageVisibility: [SelectionType.Audience],
      },
      {
        name: 'cookieEquals',
        type: SessionConditionType.CookieEquals,
        icon: 'code',
        formFieldType: 'TextField',
        requiresPopup: true,
        pageVisibility: [SelectionType.Audience],
      },
      {
        name: 'jsExpression',
        type: SessionConditionType.JsExpression,
        icon: 'code',
        formFieldType: 'CodeMirror',
        requiresPopup: true,
        pageVisibility: [SelectionType.Audience],
      },
      {
        name: 'onlyDesktop',
        type: SessionConditionType.OnlyDesktop,
        icon: 'desktop_windows',
        formFieldType: 'none',
        requiresPopup: false,
        pageVisibility: [SelectionType.Audience],
      },
      {
        name: 'onlyMobile',
        type: SessionConditionType.OnlyMobile,
        icon: 'phone_iphone',
        formFieldType: 'none',
        requiresPopup: false,
        pageVisibility: [SelectionType.Audience],
      },
      {
        name: 'domain',
        type: SessionConditionType.Domain,
        icon: 'web',
        requiresPopup: true,
        formFieldType: 'TextField',
        pageVisibility: [SelectionType.Audience],
      },
    ],
  },
  {
    type: 'widgets',
    options: [
      {
        name: 'campaignOpened',
        type: SessionConditionType.CampaignOpened,
        icon: 'person',
        formFieldType: 'NumberField',
        requiresPopup: false,
        pageVisibility: [SelectionType.Audience],
      },
      {
        name: 'campaignDismissal',
        type: SessionConditionType.CampaignDismissal,
        icon: 'person',
        formFieldType: 'NumberField',
        requiresPopup: false,
        pageVisibility: [SelectionType.Audience],
      },
      {
        name: 'campaignConversion',
        type: SessionConditionType.CampaignConversion,
        icon: 'person',
        formFieldType: 'NumberField',
        requiresPopup: false,
        pageVisibility: [SelectionType.Audience],
      },
      {
        name: 'campaignClickthrough',
        type: SessionConditionType.CampaignClickthrough,
        icon: 'person',
        formFieldType: 'NumberField',
        requiresPopup: false,
        pageVisibility: [SelectionType.Audience],
      },
      {
        name: 'campaignSurveyResponse',
        type: SessionConditionType.CampaignSurveyResponse,
        icon: 'person',
        formFieldType: 'NumberField',
        requiresPopup: false,
        pageVisibility: [SelectionType.Audience],
      },
    ],
  },
];

export const CATEGORIES_FOR_BACKOFFICE: CriteriaGroup[] = [
  {
    type: 'group',
    options: [
      {
        name: 'groupName',
        icon: 'flag',
        formFieldType: 'MultiDropdown',
        pageVisibility: [SelectionType.Backoffice],
      },
    ],
  },
];

export class CriteriaElement {
  name: string;
  icon?: string;
  svgIcon?: string;
  formFieldType: string;
  visibility?: string;
  requiresPopup?: boolean;
  pageVisibility?: number[];
  type?: SessionConditionType;
}

export class CriteriaGroup {
  type: string;
  options: CriteriaElement[];
  pageVisibility?: number[];
}

export class CriteriaList {
  category: CriteriaGroup;
  subcategory?: CriteriaGroup[];
}

export interface UtmCampaign {
  name: string;
  createdTime: Date;
  updatedTime?: Date;
}
